import { cssObj } from '@/css/resources/functions.css';
import { fluidValues } from '@/css/resources/mixins.css';
import { breakpoints } from '@/css/resources/variables.css';

const getCustomStyles = (theme) => cssObj({});

export { getCustomStyles };
